<template>
    <div>
    </div>
</template>

<script>
import { rtdb } from '../../../db'

const broadcast = rtdb.ref('broadcast')

export default {
    name: 'Broadcast',
    props: ['expoId'],
    data() {
        return {
            bcast: {},
            seen: null
        }
    },
    created() {
        this.$rtdbBind('bcast', broadcast.child(this.expoId).child('broadcasts').orderByChild('dt'))
    },
    watch: {
        bcast: {
            immediate: true,
            handler(bcast) {
                if (!this.seen) {
                    this.seen = bcast
                    return
                }
                var diff = Object.keys(bcast).filter( k => ! (k in this.seen) )
                var now = Date.now()
                for (let k of diff) {
                    if (bcast[k].dt > now - 10000) {
                        this.notif(bcast[k].text)
                    }
                    this.seen[k] = this.bcast[k]
                }
            }
        }
    }
}
</script>